var map = {
	"./award_1.png": 237,
	"./award_10.png": 3517,
	"./award_11.png": 9267,
	"./award_12.png": 1373,
	"./award_2.png": 3611,
	"./award_3.png": 6334,
	"./award_4.png": 7340,
	"./award_5.png": 2746,
	"./award_6.png": 3789,
	"./award_7.png": 6441,
	"./award_8.png": 5377,
	"./award_9.png": 5806,
	"./award_bigo.png": 3787
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7851;